if (!customElements.get('prinzap-product-slider')) {
  customElements.define('prinzap-product-slider', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const on = (target, event, callback) => target.addEventListener(event, callback, { signal: this.abort.signal });
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (this.slides.length < 2) return;
      this.index = 0; this.timer = null; this.hover = false; this.focused = false; this.visible = true; this.editing = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.delay = Math.max(4000, Number(this.dataset.interval) || 6000);
      this.slides.forEach((slide, index) => { slide.hidden = false; slide.inert = index !== 0; slide.setAttribute('aria-hidden', String(index !== 0)); });
      this.classList.add('is-ready');
      this.querySelector('.pz-slider-controls').hidden = false;
      this.toggle = this.querySelector('[data-toggle]');
      on(this.toggle, 'click', () => { this.paused = !this.paused; if (!this.paused) this.focused = false; this.paintToggle(); this.schedule(); });
      on(this.querySelector('[data-next]'), 'click', () => this.show(this.index + 1, true));
      on(this.querySelector('[data-prev]'), 'click', () => this.show(this.index - 1, true));
      on(this, 'pointerenter', e => { if (e.pointerType === 'mouse') { this.hover = true; this.schedule(); } });
      on(this, 'pointerleave', e => { if (e.pointerType === 'mouse') { this.hover = false; this.schedule(); } });
      on(this, 'focusin', () => { this.focused = true; this.schedule(); });
      on(this, 'focusout', () => queueMicrotask(() => { if (this.isConnected) { this.focused = this.contains(document.activeElement); this.schedule(); } }));
      on(this, 'pointerdown', e => { if(e.pointerType === 'touch') { this.touch = {x:e.clientX,y:e.clientY}; this.clear(); } });
      on(this, 'pointerup', e => {
        if (!this.touch) return;
        const dx=e.clientX-this.touch.x,dy=e.clientY-this.touch.y; this.touch=null;
        if (Math.abs(dx)>60 && Math.abs(dx)>Math.abs(dy)*1.5) { this.suppressClickUntil=performance.now()+500; this.show(this.index+(dx<0?1:-1),true); } else this.schedule();
      });
      on(this, 'pointercancel', () => { this.touch=null; this.schedule(); });
      on(this, 'click', e => { if(performance.now()<this.suppressClickUntil){e.preventDefault();this.suppressClickUntil=0;} });
      on(document, 'visibilitychange', () => this.schedule());
      on(this.motion, 'change', () => { if(this.motion.matches) this.paused=true; this.paintToggle(); this.schedule(); });
      on(document, 'shopify:block:select', e => {
        const index=this.slides.findIndex(s=>s.dataset.blockId===e.detail?.blockId);
        if(index<0)return; this.editing=true;this.show(index,false);
      });
      on(document, 'shopify:block:deselect', e => {
        if(this.slides.some(s=>s.dataset.blockId===e.detail?.blockId)){this.editing=false;this.schedule();}
      });
      if ('IntersectionObserver' in window) {
        this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule();});
        this.observer.observe(this);
      }
      this.paintToggle(); this.schedule();
    }
    paintToggle(){ this.toggle.textContent=this.paused?'Start':'Pause';this.toggle.setAttribute('aria-label',this.paused?'Automatischen Wechsel starten':'Automatischen Wechsel pausieren'); }
    clear(){clearTimeout(this.timer);this.timer=null;}
    schedule(){
      this.clear();
      if(this.paused||this.hover||this.focused||this.editing||!this.visible||document.hidden||!this.isConnected)return;
      // Begin fetching the following product image before its slide becomes visible.
      const next=this.slides[(this.index+1)%this.slides.length].querySelector('img'); if(next)next.loading='eager';
      this.timer=setTimeout(()=>this.show(this.index+1,false),this.delay);
    }
    show(index,manual){
      this.index=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i)=>{const active=i===this.index;slide.classList.toggle('is-active',active);slide.inert=!active;slide.setAttribute('aria-hidden',String(!active));});
      this.querySelector('[data-position]').textContent=String(this.index+1);
      if(manual)this.querySelector('[data-announcement]').textContent=`Produkt ${this.index+1} von ${this.slides.length}: ${this.slides[this.index].getAttribute('aria-label')}`;
      this.schedule();
    }
    disconnectedCallback(){this.clear();this.abort?.abort();this.observer?.disconnect();}
  });
}
